import type { ModuleNavItem } from 'app/shared/entitlement/module-nav.config';
import { getModuleUiDefinition } from './module-ui.definitions';

export function buildCollapsableNavForModule(code: string): ModuleNavItem {
    const def = getModuleUiDefinition(code);
    const children: ModuleNavItem[] = def.screens
        .filter((s) => s.showInNav)
        .map((s) => ({
            id: `${code}.${s.id}`,
            title: s.navTitle || s.title,
            type: 'basic' as const,
            icon: s.icon || 'heroicons_outline:document',
            link: `/${code}/${s.path}`,
        }));

    return {
        id: code,
        title: def.title,
        type: 'collapsable',
        icon: def.icon,
        children,
    };
}
